import { useGetCurrentUserQuery } from '_common/services/api/authority';
import { useCallback } from 'react';
import { dayjsWithTimezone } from 'utils';
import { DATE_FORMATS } from '../components/FormattedDate/FormattedDate';
import { ConfigType } from 'dayjs';

export const useFormattedDate = () => {
  const { data: user } = useGetCurrentUserQuery();

  const formatDate = useCallback(
    (
      date: ConfigType,
      type?: 'short' | 'numeric' | 'expansive' | 'extended' | 'simplistic' | 'noyear',
    ) => {
      if (!user) {
        return null;
      }

      const dayjs = dayjsWithTimezone(date, user.profile.timezone);

      return dayjs.format(DATE_FORMATS[user.profile.date_format || 'dm'][type ?? 'numeric']);
    },
    [user],
  );

  return formatDate;
};
